export const speciality_list = [
    { value: 'General dentist', label: 'General dentist' },
    { value: 'Oral and maxillofacial surgeon', label: 'Oral and maxillofacial surgeon' },
    { value: 'Endodontists', label: 'Endodontists' },
    { value: 'Orthodontists', label: 'Orthodontists' },
    { value: 'Pedodontist', label: 'Pedodontist' },
    { value: 'Periodontist', label: 'Periodontist' },
    { value: 'Prosthodontist', label: 'Prosthodontist' },
    { value: 'Oral and maxillofacial radiologist ', label: 'Oral and maxillofacial radiologist ' },
    { value: 'Orofacial Pain specialist ', label: 'Orofacial Pain specialist ' },
    { value: 'Oral Medicine specialist', label: 'Oral Medicine specialist' },
    { value: 'Dental anesthesiologist', label: 'Dental anesthesiologist' },
  ];
